import { Avatar, ListItemText, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import { useSelector } from "react-redux";
import React, { useState } from "react";
import MenuApp from "./MenuApp";
import { IReduxState } from "../../store";
import CommonLoading from "../../components/Common/CommonLoading";
import Pagination from "@mui/material/Pagination";
import { formatDateHeure } from "../../util/functions";
import { IEtabActivetedWebService, IXserverConfig } from "./interface";




const ITEMS_PER_PAGE = 10; // Nombre d'éléments par page

const Liste = () => {
  const filteredEtabActivetedWebService = useSelector((state: IReduxState) => state.xserverstates.filteredEtabActivetedWebService);
  const fetchingData = useSelector((state: IReduxState) => state.xserverstates.fetchingData);
  const etabs = useSelector((state: IReduxState) => state.focusEcole.etabs);
  console.log("🚀 ~ Liste ~ etabs:", etabs)


  const [page, setPage] = useState(1); // État pour suivre la page actuelle
  // Calculer les éléments affichés pour la page actuelle
  const startIndex = (page - 1) * ITEMS_PER_PAGE;
  const currentItems = filteredEtabActivetedWebService.slice(startIndex, startIndex + ITEMS_PER_PAGE);

  // Gestion du changement de page
  const handlePageChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);
  };

/**
 * Extrait le numéro de série du disque dur depuis la config.
 * @param cfg le champ config de l'objet IEtabActivetedWebService
 * @returns Numéro de série (sans point final) ou undefined
 */
const getHddSerial = (cfg: IXserverConfig): string | undefined => {
  if (!cfg) return undefined;

  // prendre la valeur si elle existe en camelCase ou en lowercase
  const raw = cfg.hddSerialNumber || cfg.hddserialnumber;

  if (!raw) return undefined;

  // supprime le point final éventuel (ex: "ABC123.")
  return raw.replace(/\.$/, "");
};

  return (
    <>
      <div
        style={{
          padding: 10,
          height: "40vh",
          overflow: "auto",
        }}
      >
        {fetchingData
          ? <CommonLoading />
          : <Box sx={{ flexGrow: 1, width: "100%" }}>
            <List dense={true}>
              {currentItems?.map((item: IEtabActivetedWebService, i: number) => {
                console.log("🚀 ~ map ~ currentItems:", currentItems)
                const etabFound = etabs.find((t: any) => t.codeEtab === item.codeEtab)
                // console.log("🚀 ~ etabFound:", etabFound)
                return (
                  <div key={i}>
                    <ListItem
                      secondaryAction={
                        <MenuApp
                          item={item}
                        />
                      }
                    >
                      <ListItem>
                        <ListItemText
                          primary={`${etabFound?.codeEtab} - ${etabFound?.libEtab}`}
                          secondary={
                            <Box style={{ display: "flex", flexDirection: "column" }}>
                              <Typography variant="caption">
                                {`Année scolaire: ${item.anneeScolaire} - Identifiant du service: ${item.idService} - N° disque dur:${getHddSerial(item.config) ?? ""} `}
                              </Typography>
                              <Typography variant="caption">
                                {`Date création: ${formatDateHeure(item?.createdAt)} - Date modification: ${formatDateHeure(item?.updatedAt)}`}
                              </Typography>
                            </Box>
                          }
                        />
                      </ListItem>
                    </ListItem>
                    <Divider />
                  </div>
                );
              })}
            </List>
          </Box>
        }
      </div>
      {/* Pagination */}
      <Box sx={{ display: "flex", justifyContent: "center", mt: 5 }}>
        <Pagination
          count={Math.ceil(filteredEtabActivetedWebService.length / ITEMS_PER_PAGE)}
          page={page}
          onChange={handlePageChange}
          color="primary"
        />
      </Box>
    </>
  );
};
export default Liste;
